import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React from 'react';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

/**
 * `Alert` component is used for highlighting important content.
 *  For showing messages about state of the system it is recommended to use [StatusMessage](#!/StatusMessage)
 *  or [ExtendedStatusMessage](#!/ExtendedStatusMessage).
 * @since 0.0.35
 */
var Alert = function Alert(_ref) {
  var _ref$baseClassName = _ref.baseClassName,
      baseClassName = _ref$baseClassName === void 0 ? "".concat(CLS_PREFIX, "alert") : _ref$baseClassName,
      className = _ref.className,
      intent = _ref.intent,
      children = _ref.children,
      onClose = _ref.onClose,
      props = _objectWithoutProperties(_ref, ["baseClassName", "className", "intent", "children", "onClose"]);

  return React.createElement("div", _extends({
    className: classNames(baseClassName, _defineProperty({}, "".concat(baseClassName, "--").concat(intent), intent), className)
  }, props), onClose && React.createElement("span", {
    className: "close",
    onClick: onClose
  }), children);
};

export default Alert;